import axios from "axios";

import { access_token, postRefresh } from "./backendclient";

const STORAGE_API_URL = import.meta.env.VITE_STORAGE_API_URL ?? "http://localhost:5002";

const storageServiceClient = axios.create({
  baseURL: STORAGE_API_URL,
});

// search files
export function storageServerPost(url, query) {
  return storageServiceClient
    .post(url, query, {
      headers: {
        Authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.post(url, query, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          });
        });
      } else {
        throw e;
      }
    });
}

// search tags
export function storageServerGet(url, query) {
  return storageServiceClient
    .get(url, {
      headers: {
        Authorization: "Bearer " + access_token,
        ...query,
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.get(url, {
            headers: {
              Authorization: "Bearer " + access_token,
              ...query,
            },
          });
        });
      } else {
        throw e;
      }
    });
}

// upload file
export function storageServerPut(url, meta, data, progress) {
  return storageServiceClient
    .put(url, data, {
      onUploadProgress: progress,
      headers: {
        Authorization: "Bearer " + access_token,
        ...meta,
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.put(url, data, {
            onUploadProgress: progress,
            headers: {
              Authorization: "Bearer " + access_token,
              ...meta,
            },
          });
        });
      } else {
        throw e;
      }
    });
}

// update metadata
export function storageServerPatch(url, meta) {
  return storageServiceClient
    .patch(url, meta, {
      headers: {
        Authorization: "Bearer " + access_token,
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.patch(url, meta, {
            headers: {
              Authorization: "Bearer " + access_token,
            },
          });
        });
      } else {
        throw e;
      }
    });
}

// get file
export function storageServerGetFile(url, meta) {
  return storageServiceClient
    .get(url, {
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + access_token,
        ...meta,
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.get(url, {
            headers: {
              Authorization: "Bearer " + access_token,
              ...meta,
            },
          });
        });
      } else {
        throw e;
      }
    });
}

// delete file
export function storageServerDelete(url, meta) {
  return storageServiceClient
    .delete(url, {
      headers: {
        Authorization: "Bearer " + access_token,
        ...meta,
      },
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        postRefresh().then(() => {
          return storageServiceClient.delete(url, {
            headers: {
              Authorization: "Bearer " + access_token,
              ...meta,
            },
          });
        });
      } else {
        throw e;
      }
    });
}
